import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { metaMaskWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets';
import { cookieStorage, createConfig, createStorage, http } from 'wagmi';
import * as chains from 'wagmi/chains';

import { ALCHEMY_KEY, CONNECTOR_APP_NAME, CONNECTOR_PROJECT_ID } from './common.config';

const ALCHEMY_BNB_MAINNET = `https://bnb-mainnet.g.alchemy.com/v2/${ALCHEMY_KEY}`;
const ALCHEMY_BNB_TESTNET = `https://bnb-testnet.g.alchemy.com/v2/${ALCHEMY_KEY}`;

const isClient = typeof window !== 'undefined';

const connectors = isClient
  ? connectorsForWallets(
      [
        {
          groupName: 'Recommended',
          wallets: [metaMaskWallet, walletConnectWallet],
        },
      ],
      {
        appName: CONNECTOR_APP_NAME,
        projectId: CONNECTOR_PROJECT_ID,
      },
    )
  : [];

export const wagmiConfig = createConfig({
  ssr: true,
  connectors,
  chains: Object.values(chains) as any,
  storage: createStorage({
    storage: cookieStorage,
  }),
  transports: Object.fromEntries(
    Object.values(chains).map(chain => [
      chain.id,
      http(
        chain.id === chains.bsc.id ? ALCHEMY_BNB_MAINNET : chains.bscTestnet.id === chain.id ? ALCHEMY_BNB_TESTNET : '',
      ),
    ]),
  ),
});
